"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var angular_1 = __importDefault(require("angular"));
var calendar_filter_controller_1 = __importDefault(require("./calendar-filter.controller"));
var calendar_filter_directive_1 = __importDefault(require("./calendar-filter.directive"));
exports.default = angular_1.default
    .module("directives.calendarfilter", [])
    .directive("dcCalendarFilters", calendar_filter_directive_1.default)
    .controller("dcCalendarFilterController", calendar_filter_controller_1.default);
